import styled, { css } from 'styled-components';

import {
  Card,
  Carousel,
  mediaMixin,
  StyledCarouselHeader,
  StyledCarouselScrollContainer,
  Text,
  token,
} from '@zillow/constellation';

export const StyledTourCard = styled(Card)`
  border-left: 3px solid ${token('colors.brand')};
  cursor: pointer;

  &:hover {
    border: 1px solid #006aff;
  }
`;

export const StyledCarousel = styled(Carousel)`
  & {
    ${StyledCarouselHeader} {
      ${mediaMixin(
        'xl_gte',
        css`
          padding-bottom: 16px;
        `,
      )}
    }

    ${StyledCarouselScrollContainer} {
      ${mediaMixin(
        'xl_gte',
        css`
          padding-bottom: 24px;
        `,
      )}
    }
  }
`;

export const StyledMonth = styled(Text)`
  display: inline-block;
  height: 24px;
  vertical-align: top;
  width: 25px;
`;

export const StyledDate = styled.div<{ isSelected: boolean }>`
  border: 1px solid ${token('colors.borderLight')};
  border-radius: 8px;
  cursor: pointer;
  height: 64px;
  width: 52px;

  ${(props) => css`
    ${props.isSelected &&
    css`
      background: ${token('colors.backgroundBlue')};
      border: 2px solid ${token('colors.brand')};
    `}
  `}

  ${mediaMixin(
    'sm_lte',
    css`
      width: 40px;
    `,
  )}
`;
